import { render } from "./CreateExpense.vue?vue&type=template&id=f4e63322&scoped=true"
import script from "./CreateExpense.vue?vue&type=script&lang=js"
export * from "./CreateExpense.vue?vue&type=script&lang=js"

import "./CreateExpense.vue?vue&type=style&index=0&id=f4e63322&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e63322"]])

export default __exports__